module.exports = __webpack_public_path__ + "img/reason2.c3038179.png";